import { cn } from '@amore/ui/cn'
import { Badge } from '@amore/ui/components/badge'
import { supplierStatusLabels, supplierStatusTone } from '@/lib/labels'
import type { SupplierStatus as Status } from '@/mock/types'

/**
 * The supplier's status as a coloured pill: grey Poptáváme, wine Domluveno,
 * green Podepsáno, struck-through grey Zrušeno. It's changed in the detail.
 */
export function SupplierStatus({ status, className }: { status: Status; className?: string }) {
  return (
    <Badge
      tone={supplierStatusTone(status)}
      className={cn('whitespace-nowrap', status === 'cancelled' && 'line-through', className)}
    >
      {supplierStatusLabels[status]}
    </Badge>
  )
}
